import React, { useState, useEffect } from 'react';
import { getAllUsers, updateUserStatus } from '../services/userService';

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [actionInProgress, setActionInProgress] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const { users } = await getAllUsers();
        setUsers(users);
      } catch (err) {
        console.error("Error fetching users:", err);
        setError("Failed to load users. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleBlockUser = async (userId, isCurrentlyBlocked) => {
    try {
      setActionInProgress(true);
      
      // Toggle blocked status
      await updateUserStatus(userId, !isCurrentlyBlocked);
      
      // Update the local user list
      setUsers(users.map(user => 
        user.id === userId 
          ? {...user, isBlocked: !isCurrentlyBlocked} 
          : user
      ));
      
      // Show success message
      alert(`User ${!isCurrentlyBlocked ? 'blocked' : 'unblocked'} successfully!`);
    } catch (err) {
      console.error(`Error ${isCurrentlyBlocked ? 'unblocking' : 'blocking'} user:`, err);
      setError(`Failed to ${isCurrentlyBlocked ? 'unblock' : 'block'} user. Please try again.`);
    } finally {
      setActionInProgress(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>Loading users...</div>;
  }

  if (error) {
    return <div style={{ color: 'red', padding: '20px' }}>{error}</div>;
  }

  if (users.length === 0) {
    return <div style={{ padding: '20px' }}>No users found.</div>;
  }

  return (
    <div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>User ID</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Name</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Email</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Status</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{user.id}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{user.displayName || 'Anonymous'}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{user.email || 'N/A'}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                <span style={{ 
                  display: 'inline-block',
                  padding: '3px 6px',
                  borderRadius: '3px',
                  backgroundColor: user.isBlocked ? '#ffcdd2' : '#c8e6c9',
                  color: user.isBlocked ? '#c62828' : '#2e7d32'
                }}>
                  {user.isBlocked ? 'Blocked' : 'Active'}
                </span>
              </td>
              <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                <button
                  onClick={() => handleBlockUser(user.id, user.isBlocked)}
                  disabled={actionInProgress}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: user.isBlocked ? '#4caf50' : '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  {user.isBlocked ? 'Unblock' : 'Block'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserManagement;